import { Box } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useMemo } from "react";
import autoFormDefaultValues, { buildFormSchema } from "features/PendingNewHire/Form/buildForm";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingDots from "components/Loading";
import { useNewHireJourneyDetailQuery } from "features/NewHireJourney/hooks";
import AutoSaveForm from "features/PendingNewHire/Form/AutoSaveForm";
import { v2ApiNewHireJourneyPathById } from "helpers/url/api/v2";
import { AutoFormSection } from "models/autoForm";

interface FormSchema {
  sections: AutoFormSection[];
}

interface NewHireAutoFormProps {
  newHireId: string;
  formSchema: FormSchema;
  onSuccess?: (res: any) => void;
}

export default function NewHireAutoSaveForm({ newHireId, formSchema, onSuccess }: NewHireAutoFormProps) {
  const { data: newHireJourney, isFetched } = useNewHireJourneyDetailQuery(newHireId);
  const schema = useMemo(() => buildFormSchema(formSchema?.sections), [formSchema?.sections]);

  const form = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
    values: autoFormDefaultValues(formSchema?.sections || [], newHireJourney),
    resetOptions: {
      keepDirtyValues: true,
      keepErrors: true,
      keepTouched: true,
    },
  });
  return !formSchema ? (
    <Box mt="16">
      <LoadingDots />
    </Box>
  ) : (
    <AutoSaveForm
      form={form}
      sections={formSchema?.sections}
      isLoaded={isFetched}
      submitUrl={v2ApiNewHireJourneyPathById(newHireId || "")}
      onSuccess={onSuccess}
    />
  );
}
